module.exports = __webpack_public_path__ + "img/04n.ac465a84.png";